import styled from 'styled-components';
import { ColumnCenter } from '@/components/Flex';
import {
  GAP_LAYOUT_MOBILE,
  GAP_LAYOUT_TABLET,
  PADDING_LAYOUT_VERTICAL_MOBILE,
} from '@/components/Layout';
import Section, { Props } from '@/components/Section';
import useDeviceSize from '@/hooks/mobile/useDeviceSize';

const Container = styled(ColumnCenter)`
  gap: 48px;
  width: 100%;
  max-width: 1280px;
`;

export default function SectionHomePage({
  height,
  margin,
  padding,
  title,
  children,
  ...props
}: Props) {
  // device size
  const deviceSize = useDeviceSize();

  return (
    <Section
      height={
        height ??
        (deviceSize === 'desktop'
          ? 820
          : deviceSize === 'tablet'
            ? 980
            : undefined)
      }
      margin={
        margin ?? {
          y:
            deviceSize === 'mobile'
              ? -(GAP_LAYOUT_MOBILE / 2)
              : deviceSize === 'tablet'
                ? -(GAP_LAYOUT_TABLET / 2)
                : undefined,
        }
      }
      padding={
        padding ??
        (deviceSize === 'mobile'
          ? {
              x: 16,
              y: PADDING_LAYOUT_VERTICAL_MOBILE,
            }
          : undefined)
      }
      {...props}
    >
      <Container>{children}</Container>
    </Section>
  );
}
